import React from 'react';
import UserLayout from '../components/UserLayout';
import ApplicationAttacher from '../utils/ApplicationAttacher';
const ApplicationAttacherPage: React.FC = () => {
  return <UserLayout data-id="element-4958">
      <div className="py-8 px-4 sm:px-6 lg:px-8 bg-gray-50 min-h-screen" data-id="element-4959">
        <div className="max-w-3xl mx-auto" data-id="element-4960">
          <div className="mb-6" data-id="element-4961">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-4962">
              Application Attacher
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-4963">
              Create and attach an application to reference number REF123456789
            </p>
          </div>
          <ApplicationAttacher data-id="element-4964" />
        </div>
      </div>
    </UserLayout>;
};
export default ApplicationAttacherPage;